import Axios, { AxiosInstance } from 'axios'
import { ProductAdminSettingsInterface } from '../interfaces/ProductAdminSettings.interface'
import { ValidationResponseInterface } from '../interfaces/ValidationResponse.interface'
import { MediaResponseInterface } from '@/interfaces/MediaResponse.interface'
import { apiConstants, ApiConstantsInterface } from '../constants/api.constants'

interface ProductAssignmentServiceInterface {
  getProductAdminSettings(productId: number): Promise<ProductAdminSettingsInterface>
  updateProductAdminSettings(
    productId: number,
    settings: ProductAdminSettingsInterface
  ): Promise<ProductAdminSettingsInterface>
  assignShoppingCartItem(
    shoppingCartItemId: number,
    legacyContactId: string,
    firstName: string,
    lastName: string
  ): Promise<ValidationResponseInterface>
  fetchMediaInfo(
    value: string,
    productId: number,
    productStartDate: string,
    productHeaderCode: string,
    isQrCode: boolean
  ): Promise<MediaResponseInterface>
  fetchUnAssignableHouseholdContacts(
    value: string,
    productId: number,
    productStartDate: string,
    productHeaderCode: string,
    isQrCode: boolean
  ): Promise<number[]>
}

class ProductAssignmentService implements ProductAssignmentServiceInterface {
  protected axios: AxiosInstance

  protected config: ApiConstantsInterface

  constructor(config: ApiConstantsInterface) {
      this.config = config;
      // Set up global Axios configuration here, if necessary
      Axios.defaults.baseURL = config.baseUrl;
      // You can also set headers, timeout, etc.
  }

  async getProductAdminSettings(productId: number): Promise<ProductAdminSettingsInterface> {
    const response = await Axios.get(`${this.config.productSettings}/${productId}`)
    return response.data
  }

  async updateProductAdminSettings(
    productId: number,
    settings: ProductAdminSettingsInterface
  ): Promise<ProductAdminSettingsInterface> {
    const response = await Axios.post(`${this.config.productSettings}/${productId}`, settings)
    return response.data
  }

  async assignShoppingCartItem(
    shoppingCartItemId: number,
    legacyContactId: string,
    firstName: string,
    lastName: string
  ): Promise<ValidationResponseInterface> {
    const response = await Axios.post(this.config.assign, {
      legacyContactId,
      shoppingCartItemId,
      firstName,
      lastName,
    })
    return response.data
  }

  async fetchMediaInfo(
    value: string,
    productId: number,
    productStartDate: string,
    productHeaderCode: string,
    isQrCode: boolean
  ): Promise<MediaResponseInterface> {
    const response = await Axios.post(`${this.config.media}`, {
      Value: value,
      ProductId: productId,
      ProductHeaderCode: productHeaderCode,
      ProductStartDate: productStartDate,
      IsQrCode: isQrCode,
    })
    return response.data
  }

  async fetchUnAssignableHouseholdContacts(
    value: string,
    productId: number,
    productStartDate: string,
    productHeaderCode: string,
    isQrCode: boolean
  ): Promise<number[]> {
    const response = await Axios.post(`product/${productId}/household/unassignablemembers`, {
      Value: value,
      ProductId: productId,
      ProductHeaderCode: productHeaderCode,
      ProductStartDate: productStartDate,
      IsQrCode: isQrCode,
    })
    return response.data
  }
}

const productAssignmentService = new ProductAssignmentService(apiConstants)
export { productAssignmentService }
